import {Country} from 'grpc-bob/enum_pb';

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://web-api.staging.manabie.io:31400';
export const METADATA = {
  KEY_TOKEN: process.env.REACT_APP_KEY_TOKEN || "token",
  KEY_PKG: process.env.REACT_APP_KEY_PKG || "pkg",
  KEY_VERSION: process.env.REACT_APP_KEY_VERSION || "version",
  VALUE_PKG: process.env.REACT_APP_VALUE_PKG || "com.manabie.liz",
  VALUE_VERSION: process.env.REACT_APP_VALUE_VERSION || "1.0.0",
};
export const termOfCondition = {
  [Country.COUNTRY_VN]: process.env.REACT_APP_VN_TERM || 'https://www.manabie.com/vn/term.html',
  [Country.COUNTRY_MASTER]: process.env.REACT_APP_MASTER_TERM || 'https://www.manabie.com/vn/term.html',
  [Country.COUNTRY_NONE]: process.env.REACT_APP_NONE_TERM || 'https://www.manabie.com/vn/term.html',
  [Country.COUNTRY_ID]: process.env.REACT_APP_ID_TERM || 'https://www.manabie.com/vn/term.html',
};
